define([
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"BusinessPlanning/ProductPlanProductMixin"
], function(declare,AggregateFrom,ProductPlanProductMixin) {

	return declare([AggregateFrom, ProductPlanProductMixin], {
		constructor: function(/*Object*/params) {
			// summary: Initialize variable
			var actionId = this.m_action.m_id;
			if (actionId == "AggregateFromMaterials")
				this.productClass = this._MATERIAL;
			else if (actionId == "AggregateFromStyles")
				this.productClass = this._STYLE;
			else if(actionId == "AggregateFromColorways") {
				this.productClass = this._STYLE;
				this.__aggregateClassId = this._PRODUCT_COLOR;
			} else if(actionId == "AggregateFromColorMaterials") {
				this.productClass = this._MATERIAL;
				this.__aggregateClassId = this._PRODUCT_COLOR;
			}
		},

		applyActionFilters: function(/*csi.view.Widget*/view) {
			// summary: apply filters for action BusinessPlan new BPProductPlan from Material
			var query = this._getQuery();
			if (query)
				view.relRoot.addQuery(query);

			this.inherited(arguments);
		}
	});
});